<script setup lang="ts">
import { computed, provide, ref } from 'vue'
import { useTheme } from 'vuetify'

import { $busEmit, $busOff, $busOn, emitter } from '@kidzonet/inject-bus-emit'
import { useIsRtl, useLoadLocaleMessages } from '@kidzonet/vue-i18n-package'

const theme = useTheme()

const loaded = ref(false)

declare global {
    // eslint-disable-next-line vars-on-top
    var SENTRY_RELEASE: any
}
await Promise.all([
    useLoadLocaleMessages('common'),
    useLoadLocaleMessages('web_common'),
    fetch('/config.json').then(res => res.json()),
]).then(([_a, _b, config]) => {
    Object.entries(config).forEach(([key, value]) => {
        localStorage.setItem(key, String(value))
    })
    loaded.value = true
    if (config.TAG) {
        window.SENTRY_RELEASE = {
            id: config.TAG,
        }
    }
})

document.body.classList.add(theme.global.name.value)

provide($busOn, (name: string, callback?: () => void) => {
    // eslint-disable-next-line ts/ban-ts-comment
    // @ts-ignore
    emitter.on(name, callback)
})
provide($busOff, (name: string, callback?: () => void) => {
    emitter.off(name, callback)
})
provide($busEmit, (name: string, params: any) => {
    emitter.emit(name, params)
})

const isRtl = computed(() => useIsRtl())
</script>

<template>
    <div
        v-if="loaded"
        :class="{
            'kidzonet-app': true,
            [theme.global.name.value]: theme.global.name.value,
            'kidzonet-app--rtl': isRtl,
            'kidzonet-app--ltr': !isRtl,
        }"
    >
        <router-view class="kidzonet-router-wrapper" />
        <notifications />
    </div>
    <div v-else>
        loading...
    </div>
</template>

<style>
    html, body, #app {
        block-size: 100%;
        color: var(--text-color);
        background-color: var(--app-background-color);
    }

    .kidzonet-app {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    .kidzonet-router-wrapper {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
    }

    .dark {
        background-color: var(--app-background-color);
    }

    .dark a {
        color: #fff;
    }

    /* vuetify override */

    .kidzonet-app--ltr {
        .v-field__outline__start { /* stylelint-disable-line */
            border-radius: 8px 0 0 8px !important;
        }
        .v-field__outline__end { /* stylelint-disable-line */
            border-radius: 0 8px 8px 0 !important;
        }
    }

    .kidzonet-app--rtl {
        .v-field__outline__start { /* stylelint-disable-line */
            border-radius: 0 8px 8px 0 !important;

        }
        .v-field__outline__end { /* stylelint-disable-line */
            border-radius: 8px 0 0 8px !important;
        }
    }
</style>
